import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';
import {luminaryOptions} from '../../../sectionConfig';

@customElement('visual-lightprofile-summary-lamps-grid')
export class VisualLightprofileSummaryLampsGrid extends connect(store)(LitElement) {

	static styles = [
		css`
		.lampsSection {
			border-top: 1px solid white;
			display: grid;
			gap: 0px 0px;
			grid-auto-flow: row dense;
			grid-template-columns: 4fr 8fr;
			padding: 100px 0px;
			margin: 0 var(--large-padding);
		}

		.description {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
			line-height: 22px;
			max-width: 70%;
			text-align: left;
		}

		.description h5 {
			color: var(--color-white);
			letter-spacing: 0.2;
		}

		.lampsGrid {
			display: grid;
			gap: 0px 0px;
			grid-auto-flow: row dense;
			grid-template-columns: repeat(3, 4fr);
		}

		.lampContainer {
			margin: 35px 20px;
			position: relative;
		}

		.lampDescription {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
			line-height: 22px;
		}

		.imgContainer {
			border-bottom: 1px solid #313131;
			text-align: center;
			width: 100%;
		}

		.imgContainer img {
		  	margin: auto;
			max-height: 285px;
		}

		.lampTitle {
			color: var(--color-white);
			font: var(--font-info-light);
			margin-top: -30px;
			position: absolute;
		}
		@media (max-width: 768px) {
			.lampsSection {
				display: block;
				padding: 0;
				margin: 0 var(--small-padding);
			}
			.description {
				max-width: 100%;
			}
			.lampsGrid {
				display: block;
			}
			.lampContainer {
				margin: 35px 0px;
			}
		 }
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.lang = state.status.lang;
	}
	render() {
		const s = this.state;
		const luminaryElements = luminaryOptions.map(luminary => {
		  const image = luminary.image;
		  const label = luminary.label[this.lang] || '';
		  const description = luminary.description[this.lang] || '';
		  const canBeSelected = luminary.availableForLightProfiles.includes(s.lightProfile.data.project.base);
		  return canBeSelected ? html`
			<div class="lampContainer">
			<div class="imgContainer">
				<img alt="Luminaire" src="${image}"/>
			</div>
			  <h4 class="lampTitle">${label}</h4>
			  <p class="lampDescription">${description}</p>
			</div>
		  `: html``;
		});

		return html`


		<section class="lampsSection">
			<div class="description">
				<h5>${msg('Our luminaire recommendation')}</h5>
				<p></p>
			</div>
			<div class="lampsGrid">
				${luminaryElements}
			  </div>

		  </section>

		`;
	  }

}
